import React, { Fragment, useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { updateUser } from '@actions/currentUser'
import { buildStepMapAndSectionMap, openErrorNotification } from './helpers'
import { Spin } from 'antd'
import { useHistory } from 'react-router-dom'
import { DEFAULT_ROUTE, INFO_STEP } from '@constants/routes'
import { COMPLETE, USER_INFORMATION_UPDATE } from '@components/Signup/constants'
import { selectCurrentUserStatus } from '@reducers/currentUser/currentUserSelectors'
import { SUCCEEDED, ERROR } from '@constants/fetchStatuses'
import Wizard from '@components/Wizard/Wizard'

const SignupWizard = ({ userType, userInfo: { isAppraiser, appraiserType } = {}, initialValues = {} }) => {
  const dispatch = useDispatch()
  const history = useHistory()
  const [completing, setCompleting] = useState(false)
  const currentUserStatus = useSelector(selectCurrentUserStatus)

  useEffect(() => {
    if (completing && currentUserStatus === SUCCEEDED) {
      history.push({ pathname: `/${DEFAULT_ROUTE}` })
    } else if (completing && currentUserStatus === ERROR) {
      setCompleting(false)
      openErrorNotification()
    }
  }, [completing, currentUserStatus, history])

  const onComplete = () => {
    dispatch(updateUser({ signup_progress: COMPLETE }, USER_INFORMATION_UPDATE))
    setCompleting(true)
  }

  const onBacktrack = () => history.push({ pathname: INFO_STEP })

  const { stepMap, sectionMap, initialStepName } = buildStepMapAndSectionMap({
    userType,
    isAppraiser,
    appraiserType,
    initialValues,
    onComplete,
  })

  return (
    <Fragment>
      <Spin tip="Loading..." spinning={completing} size="large" className="full-page-spinner">
        <div className="step-header">
          <h1>Account Setup</h1>
        </div>
        <Wizard
          stepMap={stepMap}
          sectionMap={sectionMap}
          initialStepName={initialStepName}
          onComplete={onComplete}
          onBacktrack={onBacktrack}
        />
      </Spin>
    </Fragment>
  )
}

export default SignupWizard
